import { ApiResponse, axiosInstance } from '@/lib/axios';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/react-query';
import { TConnectWhatsapp } from '../types/connect-whatsapp.type';

/**
 * Get Qr Whatsapp
 */
export type TGetQrWhatsappRequest = {
  organizationChannelId: string;
};
export type TGetQrWhatsappResponse = ApiResponse<TConnectWhatsapp>;

export const getQrWhatsapp = async (params: TGetQrWhatsappRequest): Promise<TGetQrWhatsappResponse> => {
  const url = `/integration/whatsapp/get-qr/${params.organizationChannelId}`;

  return axiosInstance.get(url, { params });
};

/**
 * Use Get Qr Whatsapp React-Query Hook
 */
export const GET_WHATSAPP_QR_QUERY_KEY = 'get-qr-whatsapp';

export const getQrWhatsappQueryOptions = (params: TGetQrWhatsappRequest) => {
  return queryOptions({
    queryKey: [GET_WHATSAPP_QR_QUERY_KEY, params.organizationChannelId],
    queryFn: () => getQrWhatsapp(params),
  });
};

type UseGetQrWhatsappOptions = {
  params: TGetQrWhatsappRequest;
  queryConfig?: QueryConfig<typeof getQrWhatsappQueryOptions>;
};

export const useGetQrWhatsapp = ({ params, queryConfig }: UseGetQrWhatsappOptions) => {
  return useQuery({
    ...getQrWhatsappQueryOptions(params),
    ...queryConfig,
  });
};

/**
 * Use Get Qr Whatsapp With Polling React-Query Hook
 */
export const GET_WHATSAPP_QR_WITH_POLLING_QUERY_KEY = 'get-qr-whatsapp-with-polling';
export const DEFAULT_WHATSAPP_QR_POLLING_INTERVAL = 3000;

export const getWhatsappQrWithPollingQueryOptions = (params: TGetQrWhatsappRequest) => {
  return queryOptions({
    queryKey: [GET_WHATSAPP_QR_WITH_POLLING_QUERY_KEY, params.organizationChannelId],
    queryFn: () => getQrWhatsapp(params),
    refetchOnWindowFocus: false,
    refetchInterval: DEFAULT_WHATSAPP_QR_POLLING_INTERVAL,
    staleTime: 0,
    gcTime: 0, // optional: immediately garbage collect cache when unused
  });
};

type UseGetQrWhatsappWithPollingOptions = {
  params: TGetQrWhatsappRequest;
  queryConfig?: QueryConfig<typeof getWhatsappQrWithPollingQueryOptions>;
};

export const useGetQrWhatsappWithPolling = ({ params, queryConfig }: UseGetQrWhatsappWithPollingOptions) => {
  return useQuery({
    ...getWhatsappQrWithPollingQueryOptions(params),
    ...queryConfig,
  });
};
